(function () {
  'use strict';
  if (window.FlorameShopifyAccountUi?.loaded) return;
  var entry = document.currentScript;
  var url = entry?.getAttribute('data-florame-account-runtime');
  if (!url) return;
  var loading = null, retries = 0, epoch = 0;
  function load() {
    if (window.FlorameShopifyAccountUi?.loaded) return Promise.resolve(window.FlorameShopifyAccountUi);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var source = new URL(url, document.baseURI);
      if (retries) source.searchParams.set('florame_account_retry', String(retries));
      script.src = source.href; script.async = true;
      if (entry.nonce) script.nonce = entry.nonce;
      var timer = setTimeout(function () { finish(new Error('account_runtime_timeout')); }, 15000);
      function finish(error) {
        clearTimeout(timer); script.onload = null; script.onerror = null;
        if (error) { script.remove(); reject(error); }
        else resolve(window.FlorameShopifyAccountUi);
      }
      script.onload = function () { finish(window.FlorameShopifyAccountUi?.loaded ? null : new Error('account_runtime_unavailable')); };
      script.onerror = function () { finish(new Error('account_runtime_unavailable')); };
      document.head.appendChild(script);
    }).catch(function (error) { loading = null; retries++; throw error; });
    return loading;
  }
  var stub = {
    loaded: false,
    version: 'loader-1.0.0',
    open: function (options) {
      var requestedEpoch = epoch;
      return load().then(function (api) { return requestedEpoch === epoch ? api.open(options) : false; }).catch(function () { return false; });
    },
    isOpen: function () { return false; },
    diagnostics: function () { return []; },
    refresh: function () { return load().then(function (api) { return api.refresh(); }).catch(function () {}); }
  };
  window.FlorameShopifyAccountUi = stub;
  window.addEventListener('florame:account-center-open', function () { load().catch(function () {}); });
  window.addEventListener('pagehide', function () { epoch++; });
  document.addEventListener('click', function (event) {
    if (window.FlorameShopifyAccountUi?.loaded) return;
    var trigger = event.target.closest?.('[data-florame-shopify-account-lazy]');
    if (!trigger || trigger.hasAttribute('data-florame-account-trigger')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var returnTo = location.pathname + location.search + location.hash;
    stub.open({ trigger: trigger }).then(function (opened) {
      if (!opened) location.assign('/customer_authentication/login?return_to=' + encodeURIComponent(returnTo));
    });
  }, true);
})();
